import { gql } from '@/lib/api';

/** OS-1726 — reportes cross-tenant (solo agregados; los montos solo con billing.read). */
export interface ModuleAdoption {
  moduleKey: string;
  name: string;
  isCore: boolean;
  enabledTenants: number;
  billedTenants: number;
  usedTenants: number | null;
  usageSignal: string | null;
}

export interface TenantUsage {
  tenantId: string;
  name: string;
  planStatus: string;
  avgDau: number;
  activeDays: number;
  lastActivity: string | null;
}

export interface TenantMrr {
  tenantId: string;
  name: string;
  planStatus: string;
  mrr: number;
  potentialMrr: number;
}

/** OS-1724 — cuánto del mes tiene historial (MRR desde OS-1723, estados desde OS-1720). */
export type HistoryCoverage = 'complete' | 'partial' | 'none';

export interface MonthlyPoint {
  month: string;
  mrrCoverage: HistoryCoverage;
  lifecycleCoverage: HistoryCoverage;
  mrr: number | null;
  payingTenants: number;
  conversions: number;
  pilotsCancelled: number;
  conversionRate: number | null;
  churnedTenants: number;
  churnRate: number | null;
}

export interface PlatformReports {
  generatedAt: string;
  currency: string;
  usageDays: number;
  totalTenants: number;
  canSeeBilling: boolean;
  mrrTrackedSince: string | null;
  lifecycleTrackedSince: string | null;
  adoption: ModuleAdoption[];
  usage: TenantUsage[];
  mrrByTenant: TenantMrr[] | null;
  mrrByModule: { moduleKey: string; mrr: number }[] | null;
  monthly: MonthlyPoint[];
}

export const reportsQueryKey = (months: number): readonly unknown[] => ['platform-reports', months];

export async function getPlatformReports(months: number): Promise<PlatformReports> {
  const data = await gql<{ platformReports: PlatformReports }>(
    `query PlatformReports($months: Int) { platformReports(months: $months) {
      generatedAt currency usageDays totalTenants canSeeBilling mrrTrackedSince lifecycleTrackedSince
      adoption { moduleKey name isCore enabledTenants billedTenants usedTenants usageSignal }
      usage { tenantId name planStatus avgDau activeDays lastActivity }
      mrrByTenant { tenantId name planStatus mrr potentialMrr }
      mrrByModule { moduleKey mrr }
      monthly { month mrrCoverage lifecycleCoverage mrr payingTenants conversions pilotsCancelled conversionRate churnedTenants churnRate }
    } }`,
    { months },
  );
  return data.platformReports;
}
